import React, { useEffect, useRef, useState } from 'react';
import './IncomingCall.css';

function IncomingCall({ callerInfo, onAccept, onDecline }) {
  const audioRef = useRef(null);
  const [currentTime, setCurrentTime] = useState('');

  // Update North Pole time (Alaska timezone)
  useEffect(() => {
    const updateTime = () => {
      const alaskaTime = new Date().toLocaleTimeString('en-US', {
        timeZone: 'America/Anchorage',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      setCurrentTime(alaskaTime);
    };

    updateTime();
    const timeInterval = setInterval(updateTime, 1000);

    return () => clearInterval(timeInterval);
  }, []);

  // Play ringing sound
  useEffect(() => {
    const audio = new Audio(`${process.env.PUBLIC_URL || ''}/audio/ringtones/santa-chime.wav`);
    audio.loop = true;
    audio.volume = 0.6;
    audioRef.current = audio;

    audio.play().catch(err => {
      console.log('Audio autoplay prevented:', err);
    });

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
    };
  }, []);

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const handleAccept = () => {
    stopAudio();
    onAccept();
  };

  const handleDecline = () => {
    stopAudio();
    onDecline();
  };

  const getCallerImage = () => {
    switch(callerInfo.callerType) {
      case 'SANTA':
        return '/Images/Santa-call-portrait.webp';
      case 'ELF':
      case 'ELF_MALE':
      case 'ELF_FEMALE':
        return '/Images/Elf_Calling-optimized.webp';
      case 'MRS_CLAUS':
        return '/Images/MrsClaus_Calling.png';
      case 'GRANDPA_JOE':
        return '/Images/Santa-call-portrait.webp';
      default:
        return '/Images/Santa-call-portrait.webp';
    }
  };

  const getCallerName = () => {
    switch(callerInfo.callerType) {
      case 'SANTA':
        return 'Santa';
      case 'ELF':
      case 'ELF_MALE':
        return 'Jingle Jack';
      case 'ELF_FEMALE':
        return 'Snowdrop Ellie';
      case 'MRS_CLAUS':
        return 'Mrs. Claus';
      case 'GRANDPA_JOE':
        return 'Santa';
      default:
        return 'Santa';
    }
  };

  return (
    <div className="incoming-call">
      {/* Background image */}
      <div
        className="call-background"
        style={{ backgroundImage: `url(${getCallerImage()})` }}
      />

      {/* Dark overlay */}
      <div className="call-overlay" />

      {/* Main content */}
      <div className="call-content">
        {/* Top section - caller info */}
        <div className="caller-info">
          <img
            src={getCallerImage()}
            alt={getCallerName()}
            className="caller-avatar"
          />
          <h1 className="caller-name">{getCallerName()}</h1>
          <p className="caller-status">Incoming Call...</p>
          <p className="caller-location-text">North Pole • {currentTime}</p>
        </div>

        {/* Bottom section - call actions */}
        <div className="call-actions">
          {/* Main action buttons */}
          <div className="main-actions">
            <button className="action-btn decline-btn" onClick={handleDecline}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.68-1.36-2.66-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"/>
              </svg>
            </button>

            <button className="action-btn accept-btn" onClick={handleAccept}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
              </svg>
            </button>
          </div>

          <div className="action-labels">
            <span className="action-label">Decline</span>
            <span className="action-label">Accept</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IncomingCall;
